import { uniqueId } from "../utilities/uniqueId";

interface LatLng {
    lat: number;
    lng: number;
}

export interface Office {
    id: string;
    name: string;
    address1: string;
    address2: string;
    directionsUrl: string;
    mapUrl: string;
    position: LatLng;
}

export const headquarters: Office = {
    id: uniqueId(),
    name: "Headquarters",
    address1: "18201 Von Karman, Suite 330",
    address2: "Irvine, CA 92612",
    directionsUrl: "https://www.google.com/maps/dir//18201+Von+Karman+Ave+%23330,+Irvine,+CA+92612",
    mapUrl: "https://www.google.com/maps/place/18201+Von+Karman+Ave+%23330,+Irvine,+CA+92612",
    position: { lat: 33.678141, lng: -117.853590}
};

export const dallas: Office = {
    id: uniqueId(),
    name: "Irving",
    address1: "320 Decker Drive",
    address2: "Irving, TX 75062",
    directionsUrl: "https://www.google.com/maps/dir//320+Decker+Dr,+Irving,+TX+75062",
    mapUrl: "https://www.google.com/maps/place/320+Decker+Dr,+Irving,+TX+75062",
    position: { lat: 32.86071934972589, lng: -96.93951117753939 }
};

export const pittsburgh: Office = {
    id: uniqueId(),
    name: "Pittsburgh",
    address1: "651 Holiday Drive, Plaza 5, Ste. 400",
    address2: "Pittsburgh, PA 15220",    
    directionsUrl: "https://www.google.com/maps/dir//651+Holiday+Dr,+Pittsburgh,+PA+15220",
    mapUrl: "https://www.google.com/maps/place/651+Holiday+Dr,+Pittsburgh,+PA+15220/@40.4218257,-80.0613854,18.75z",
    position: { lat: 40.4218257, lng: -80.0613854 }
};

export const offices: Office[] = [
    headquarters,
    dallas,
    pittsburgh
];